import { useGetSmsCampaigns } from "../../../../../hooks/api/queries/useMarketing";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";

export const useAllSmsCampaigns = () => {
  const { search, queries, filterBySearch, filterByKey } = useUrlSearch();
  const { data, isLoading } = useGetSmsCampaigns({
    queries,
    queryParams: { campaign_type: "CUSTOM|RECOMMENDED" },
  });

  return {
    campaigns: data?.data || [],
    metaDetails: data?.meta || {},
    isLoadingSmsCampaigns: isLoading,
    search,
    filterByKey,
    filterBySearch,
  };
};
